import React, { Component } from 'react'
import {
    Container,
    Form,
    Button,
    Nav,
    NavItem,
    NavLink
} from 'reactstrap';


class review22_3 extends Component {
    render() {
        return (
            <div>
                <Container className="comming">
                <Form className="boxreview">
                        <h1 className="textrandomtest1">Review แบบทดสอบ</h1>
                        <Form className="Q1">
                           <h3 h5 align='center'>คะแนนที่คุณได้</h3>  <br></br>
                           <h1 h5 align='center'>3</h1><br></br>
                           
                           <h5 className="textreview">1. เวลาใดที่กินเวลาน้อยที่สุด </h5> <h5 className="textreviewtrue">(ท่านตอบข้อนี้ถูกต้อง)</h5>
                           <Form className="b1">
                           <h5 className="textreviewF">ก.อดีต</h5>
                           <h5 className="textreviewT">ข.ปัจจุบัน</h5>
                           <h5 className="textreviewF">ค.อนาคต</h5>
                           </Form>

                           <h5 className="textreview">2. คำกล่าวเกี่ยวกับอาณาจักรทวารวดีในข้อใดถูกต้องที่สุด</h5> <h5 className="textreviewfail">(ท่านตอบข้อนี้ผิด)</h5>
                           <Form className="b1">
                           <h5 className="textreviewT">ก. เป็นอาณาจักรแห่งแรกในดินแดนไทย</h5>
                           <h5 className="textreviewF">ข. ช่วยถ่ายทอดวัฒนธรรมไปสู่ดินแดนอื่น</h5>
                           <h5 className="textreviewF">ค. นำดินแดนไทยเข้าสู่สมัยประวัติศาสตร์</h5>
                        </Form>

                        <h5 className="textreview">3. โบราณสถานกับอาณาจักรโบราณในข้อใดที่จัดความสัมพันธ์ไม่ถูกต้อง</h5>  <h5 className="textreviewtrue">(ท่านตอบข้อนี้ถูกต้อง)</h5>
                           <Form className="b1">
                           <h5 className="textreviewF">ก. พระปฐมเจดีย์  : ทวารวดี</h5>
                           <h5 className="textreviewF">ข. พระบรมธาตุเจดีย์  : ตามพรลิงค์</h5>
                           <h5 className="textreviewT">ค. พระธาตุหริภุญชัย : โยนกเชียงแสน</h5>
                        </Form>

                        <h5 className="textreview">4. หลักเกณฑ์การเปรียบเทียบศักราชในข้อใด  ระบุได้ถูกต้อง</h5> <h5 className="textreviewfail">(ท่านตอบข้อนี้ผิด)</h5>
                           <Form className="b1">
                           <h5 className="textreviewF">ก. ม.ศ. +  1122     =   พ.ศ.</h5>
                           <h5 className="textreviewF">ข. จ.ศ.  +  2324   =   พ.ศ.</h5>
                           <h5 className="textreviewF">ค. ร.ศ. +  1181    =   พ.ศ.</h5>
                           <h5 className="textreviewT">ง. ค.ศ. +  543      =   พ.ศ.</h5>
                        </Form>

                        <h5 className="textreview">5. การใช้ศักราชในประวัติศาสตร์ไทยตามหลักฐานข้อใด  ไม่สมเหตุสมผล</h5>  <h5 className="textreviewtrue">(ท่านตอบข้อนี้ถูกต้อง)</h5>
                           <Form className="b1">
                           <h5 className="textreviewT">ก. เมื่อปีมะเมีย  ค.ศ. 1595  พระเจ้าจันทโชติได้สวยราชสมบัติกรุงะโว้</h5>
                           <h5 className="textreviewF">ข. 1205  ศก ปีมะแม  พ่อขุนรามคำแหง  หาใคร่ใจในใจแลใส่ลายสือไทยนี้</h5>
                           <h5 className="textreviewF">ค. ศุภมัสดุ  ศักราช 721 ปีขาลโทศก ..... สถาปนากรุงพระนครศรีอยุธยา</h5>
                           <h5 className="textreviewF">ง. วันที่ 19  เมษายน รัตนโกสินทร์ศก  ถึงที่ประชุมเสนาบดี ซึ่งอยู่รักษาพระนคร</h5>
                        </Form>
                           
                           <p  h5 align='center'><Button href='/randomtest' color="#4fc3f7 light-blue lighten-2" >กลับหน้าหลัก</Button>{' '}</p>
                        </Form>
                       
                </Form>
                </Container>
               
                <div className="footer text-footer">
                    <p>Surasak   Noorurk</p>
                    <p> Project 5935512072 Computer Engineering</p>
                    <NavLink href="https://www.facebook.com/few.connectfve">ช่องทางการติดต่อ</NavLink>
                       
                </div>

            </div> 
        )
    }
}

export default review22_3